'use strict';

class EventPipe {
  constructor() {
    this.eventsHash = {};
  }

  on(eventName, cb, context) {
    if (!this.eventsHash[eventName]) {
      this.eventsHash[eventName] = [];
    }
    const boundCb = context ? cb.bind(context) : cb;
    this.eventsHash[eventName].push(boundCb);
  }

  off(eventName) {
    this.eventsHash[eventName] = undefined;
  }

  trigger(eventName) {
    Array.isArray(this.eventsHash[eventName])
      ? this.eventsHash[eventName].forEach(fn =>
          fn(...[].slice.call(arguments, 1))
        )
      : undefined;
  }

  once(eventName, cb, context) {
    const boundOff = this.off.bind(this);
    const onceCb = () => {
      cb(...arguments);
      boundOff(eventName);
    };
    this.on(eventName, onceCb, context);
  }
}

window.DealEventPipe = new EventPipe();
module.exports = EventPipe;



// WEBPACK FOOTER //
// ./modules/deal/frontend/event_pipe.js